import React, { useRef, useState, useEffect } from 'react'
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';

import { Alert, AvatarGroup, Checkbox, CircularProgress, Container, Fade, Grid, Icon, List, ListItem, ListItemAvatar, ListItemText, Zoom } from '@mui/material'
import Sidebar from '../../components/Sidebar';

import { AiOutlineClose, AiOutlineConsoleSql } from "react-icons/ai";


// Importaciones para el modal
import { Button, Modal, Box, Typography, TextField, Tabs, Tab, Divider, Switch, Card, Avatar, IconButton, Chip, Autocomplete } from '@mui/material';


// Iconos
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import CircleIcon from '@mui/icons-material/Circle';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import PublicIcon from '@mui/icons-material/Public';
import SearchIcon from '@mui/icons-material/Search';
import HttpsIcon from '@mui/icons-material/Https';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'; // Tres puntos horizontales
import RemoveIcon from '@mui/icons-material/Remove';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CloseIcon from '@mui/icons-material/Close';
import ImageIcon from '@mui/icons-material/Image';

// Redux
import store from '../../store';
import { EVENTMODAL_action, GUESTSMODAL_action } from '../../store/actions/modalAction';
import { CREATE_EVENT_action } from '../../store/actions/eventAction';

// Date y time pickers
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es'; // Importa el idioma español
import { MobileTimePicker, StaticDateTimePicker, StaticTimePicker } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';


// Componentes de Material UI
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import InputAdornment from '@mui/material/InputAdornment';

import ButtonBase from '@mui/material/ButtonBase';

import hamburguesa from '../../images/hamburguesa.jpg'

// Componentes de JOY UI
import { AspectRatio, Input, Textarea } from '@mui/joy';
import CateringCard from '../../components/Cards/CateringCard';
import Header from '../../components/Header';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import axios from 'axios';
import { connect } from 'react-redux';
import CryptoJS from "crypto-js";
import {
    APIProvider,
    Map,
    AdvancedMarker,
    MapCameraChangedEvent,
    Pin
} from '@vis.gl/react-google-maps';
import MapWithAutocomplete from '../../components/maps';
import imageCompression from 'browser-image-compression';






const mapStateToProps = (state) => {
    return {
        page: state.pageReducer.pageName,
        user: state.userReducer,
        eventModalState: state.modalReducer.eventModalState,
        guestsModalState: state.modalReducer.guestsModalState,
        eventDetailsReducer: state.eventDetailsReducer,
    }
}


const Maps = ({ defaultCenter, initialCoords, onLocation }) => {
    // Estado para almacenar el centro inicial del mapa
    const [initialMapCenter, setInitialMapCenter] = useState(defaultCenter);
    // Estado para controlar el centro actual del mapa
    const [mapCenter, setMapCenter] = useState(defaultCenter);

    // Función para restablecer el centro del mapa a la posición inicial
    const handleResetCenter = () => {
        setMapCenter(initialMapCenter);
    };

    // Función que se ejecuta cuando el usuario mueve el mapa
    const handleCameraChanged = (ev) => {
        const newCenter = ev.detail.center;
        setMapCenter(newCenter); // Actualiza el centro actual del mapa
        onLocation(newCenter); // Llama a la función onLocation con el nuevo centro
    };

    return (
        <APIProvider>
            <div style={{ position: 'relative' }}>
                <Map
                    style={{ width: '100%', height: 300 }}
                    center={mapCenter} // Usamos el estado para controlar el centro del mapa
                    defaultZoom={15}
                    gestureHandling={'greedy'}
                    disableDefaultUI={true}
                    onCameraChanged={handleCameraChanged} // Escucha los cambios en la cámara
                    mapId='AIzaSyAv2gmZYl03K-EsNmKwOF0rNhO1YMrvj5Q'
                >
                    <PoiMarkers pois={[{ key: 'location', location: { lat: initialCoords.lat, lng: initialCoords.lng } }]} />
                </Map>
                {/* Botón para restablecer el centro del mapa */}
                <IconButton
                    onClick={handleResetCenter}
                    style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}
                >
                    <RestartAltIcon />
                </IconButton>
            </div>
        </APIProvider>
    );
};

const PoiMarkers = (props) => {
    return (
        <>
            {props.pois.map((poi) => (
                <AdvancedMarker
                    key={poi.key}
                    position={poi.location}
                >
                    <Pin background={'#FBBC04'} glyphColor={'#000'} borderColor={'#000'} />
                </AdvancedMarker>
            ))}
        </>
    );
};

const EditEvent = (props) => {

    const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false); // Estado para la pantalla de carga


    let [publicKey, setPublicKey] = useState('');
    let statePublicKey = '';
    let [privateKey, setPrivateKey] = useState('');
    let statePrivateKey = '';

    const fileInputRef = useRef(null);
    // VARIABLES PRIMERA PARTE
    const [eventName, setEventName] = useState('')
    const [eventDescription, setEventDescription] = useState('')
    const [eventImage, setEventImage] = useState('')
    const [initialEventImage, setInitialEventImage] = useState('')

    let startCoords = '';
    let [eventLocation, setEventLocation] = useState('')
    let [eventCoords, setEventCoords] = useState('')
    let [inicialEventCoords, setInicialEventCoords] = useState('')
    let [inicialEventLocation, setInicialEventLocation] = useState('')
    let [coordsRenovadas, setCoordsRenovadas] = useState('')

    // const [selectedDate, setSelectedDate] = useState(dayjs('2024-04-17'))
    const [selectedDate, setSelectedDate] = useState(null)

    const [traducedDate, setTraducedDate] = useState(null)
    const [eventImageBlob, setEventImageBlob] = useState('')

    // const [selectedHour, setSelectedHour] = useState(null)
    // const [selectedHour, setSelectedHour] = useState(dayjs().hour(14).minute(30));
    const [selectedHour, setSelectedHour] = useState(null);

    let [locationValid, setLocationValid] = useState(false)

    const [traducedHour, setTraducedHour] = useState(null)

    let [eventTypeManual, setEventTypeManual] = useState('') // Tipo de Evento
    let [eventTypeAuto, setEventTypeAuto] = useState(null) // Tipo de Evento
    let [typeAlert, setTypeAlert] = useState('')

    let [eventPrivacity, setEventPrivacity] = useState(false) // Tipo de Evento

    let [guests, setGuests] = useState([]) // Aca se almacenaran los usuarios invitados

    let [selectedGuest, setSelectedGuest] = useState(null) // Aca se almacenaran los datos del usuario a invitar

    let [eventCaracteristics, setEventCaracteristics] = useState('')

    let [tabValue, setTabValue] = useState(0);
    const [guestsView, setGuestsView] = useState(false)

    const [eventCreator, setEventCreator] = useState('')

    // VARIABLES PARA TIPO DE PRIVACIDAD
    const [indexEventPrivacity, setIndexEventPrivacity] = useState(0)

    const [showAlert, setShowAlert] = useState(false)
    let [alertMsg, setAlertMsg] = useState('')

    let [friends, setFriends] = useState([]);
    let [searchFriends, setSearchFriends] = useState('')

    const filteredFriends = friends.filter(friend =>
        friend.nameUser.toLowerCase().includes(searchFriends.toLowerCase())
    );



    // LISTADO DE USUARIOS DISPONIBLES PARA INVITAR AL EVENTO A CREAR
    const [availableUsers, setAvailableUsers] = useState([]);


    const eventTypes = [
        'No definido',
        'Cumpleaños',
        'Reunión Laboral Virtual',
        'Reunión Laboral Presencial',
        'Casamiento',
        'Viaje',
        'Juntada común',
        'Club Nocturno',
        'Fiesta Nacional',
        'Funcion Teatral',
        'Show musical',
        'Evento al aire libre',
        'Evento Virtual',
    ];


    // VARIABLES PARA HABILITAR DISTINTAS CARACTERISTICAS DEL EVENTO
    let [enableGuests, setEnableGuests] = useState(false) // Su valor cambia al seleccionar Publico o Privado


    // let [selectedUser, setSelectedUser] = useState()


    // FUNCIONES ----------------------------------------------------------------
    // Función para manejar el cambio de pestañas
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // FUNCION PARA CREAR EL EVENTO FINALMENTE
    async function editEvent() {
        // VALIDACION DATOS OBLIGATORIOS
        if (eventName == '' || selectedDate == null || selectedHour == null) {
            let errores = ''
            setShowAlert(true)

            if (eventName == '') {
                errores += ' | Nombre del evento '
            }

            if (selectedDate == null) {
                errores += ' | Día de Inicio '
            }

            if (selectedHour == null) {
                errores += ' | Hora de Inicio '
            }

            setAlertMsg(errores)

        } else {

            setLoading(true); // Mostrar pantalla de carga
            try {


                let eventType = ''
                let privacity = ''
                if (eventPrivacity === true) {
                    privacity = 'PRIVADO'
                } else {
                    privacity = 'PUBLICO'
                }

                if (eventTypeAuto !== null) {
                    eventType = eventTypeAuto
                } else {
                    eventType = eventTypeManual
                }


                let compressedFile;
                var imageUrl = "";
                // let formData = new FormData();

                if (eventImageBlob) {
                    console.log("eventImageBlob")
                    console.log(eventImageBlob)

                    const options = {
                        maxSizeMB: 1, // Tamaño máximo en MB
                        maxWidthOrHeight: 1024, // Resolución máxima
                        useWebWorker: true, // Usar Web Worker para mejor rendimiento
                        fileType: 'image/webp', // Convertir a WebP
                    };

                    try {
                        compressedFile = await imageCompression(eventImageBlob, options);
                        imageUrl = await uploadImageToBackend(compressedFile);
                        // formData.append('file', compressedFile);
                    } catch (error) {
                        console.error('Error comprimiendo la imagen:', error);
                    }
                }



                let guestsTraduccion = ""
                // console.log(guests)
                friends.map((item, index) => {
                    if (item.selected == true) {
                        guestsTraduccion += item.userID + "; "
                    }
                })

                const headers = 'content-type: application/json; charset=utf-8'

                const token = localStorage.getItem('jwt_token');

                var userData = JSON.parse(localStorage.getItem('userData'))

                const data = {
                    "eventID": props.eventDetailsReducer.eventId,
                    "eventType": (eventType == '' ? 'No definido' : eventType),
                    "creatorAvatar": userData.avatar,
                    "eventTitle": eventName,
                    "creatorId": props.user.id,
                    "guestsId": (privacity === 'PUBLICO' ? '' : guestsTraduccion),
                    "creatorName": props.user.nombre,
                    "eventDescription": eventDescription,
                    "startDay": selectedDate,
                    "startHour": traducedHour,
                    "eventLocationCoords": (coordsRenovadas == "" ? '' : JSON.stringify(eventCoords)),
                    // "eventLocation": eventLocation,
                    "eventLocation": coordsRenovadas,
                    "eventPrivacity": privacity,
                    "eventImage": imageUrl ? imageUrl : eventImage,
                    "eventCharacteristics": eventCaracteristics,
                    "loginWithKey": "false"
                }

                console.log("data")
                console.log(data)


                const jsonData = JSON.stringify(data);
                const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

                await axios.put('https://socializeapi.azurewebsites.net/api/UpdateEvent', { data: data_encripted }, {
                    headers
                })
                    .then(response => {
                        // enviarnotificaciones();
                        enviarnotificacionEditedEvent(data);
                    })
                    .catch(error => {
                        console.log(`Error obteniendo datos: ${error}`);
                        if (error == "AxiosError: Request failed with status code 401") {
                            navigate("/login")
                            alert("Sesión caducada!")
                        }
                    });

            } catch (error) {
                console.log(`Error obteniendo datos: ${error}`);
            } finally {
                setLoading(false); // Ocultar pantalla de carga
                navigate('/')
                store.dispatch(CHANGE_PAGE_action(''))
            }

        }
    }

    const handleCheckboxChange = (index) => {
        setFriends(prevFriends => {
            const updatedFriends = [...prevFriends];
            updatedFriends[index].selected = !updatedFriends[index].selected;
            return updatedFriends;
        });
    };

    async function getFriends() {
        const token = localStorage.getItem('jwt_token');

        var data = {
            userID_1: props.user.id
        }

        // const jsonData = JSON.stringify(data);
        // const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        const headers = 'content-type: application/json; charset=utf-8'
        console.log("getFriends")
        await axios.post(`https://socializeapi.azurewebsites.net/api/getfriends`, data, {
            headers
        })
            .then(response => {
                console.log(response.data)
                const friendsWithSelected = response.data.map(friend => {
                    return {
                        ...friend,
                        selected: false // Puedes establecer el valor inicial que desees, en este caso 'false'
                    };
                });
                console.log("updatedFriends")
                console.log(props.eventDetailsReducer.guestsId)

                const updatedFriends = friendsWithSelected.map(item => {
                    // Verifica si el userID está en eventDetailsReducer
                    if (props.eventDetailsReducer.guestsId.includes(item.userID)) {
                        // Devuelve una copia del objeto con selected en true
                        return { ...item, selected: true };
                    }
                    // Si no está seleccionado, devuelve el objeto original
                    return item;
                });

                setFriends(updatedFriends)
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
                if (error == "AxiosError: Request failed with status code 401") {
                    navigate("/login")
                    alert("Sesión caducada!")
                }
            })
    }

    const uploadImageToBackend = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch('https://socializeapi.azurewebsites.net/api/upload', {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const data = await response.json(); // Obtener la URL de la respuesta
            console.log('Imagen subida con éxito. URL:', data.url);
            return data.url; // Retornar la URL para asociarla al evento
        } else {
            console.error('Error subiendo la imagen');
            throw new Error('Error al subir la imagen')
        }
    };

    async function enviarnotificaciones() {
        let guestsTraduccion = ""
        // console.log(guests)
        guests.map((item, index) => {
            guestsTraduccion += item.UserID + "; "
        })

        const headers = 'content-type: application/json; charset=utf-8'
        await obtenerVAPID()

        const data = {
            "privateKey": statePrivateKey,
            "publicKey": statePublicKey,
            "userAgent": navigator.userAgent,
            "invitedUsers": guestsTraduccion
        }

        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();



        await axios.post('https://socializeapi.azurewebsites.net/api/send-notification', { data: data_encripted }, {
            headers
        })
            .then(response => {
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
                if (error == "AxiosError: Request failed with status code 401") {
                    navigate("/login")
                    alert("Sesión caducada!")
                }
            });
    }

    async function enviarnotificacionEditedEvent(eventData) {
        let guestsTraduccion = ""
        // console.log(guests)
        friends.map((item, index) => {
            if (item.selected == true) {
                guestsTraduccion += item.userID + "; "
            }
        })

        const headers = 'content-type: application/json; charset=utf-8'
        await obtenerVAPID()

        const data = {
            "privateKey": statePrivateKey,
            "publicKey": statePublicKey,
            "userAgent": navigator.userAgent,
            "invitedUsers": guestsTraduccion,
            "eventData": eventData,
            "action": "editedevent"
        }

        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();



        await axios.post('https://socializeapi.azurewebsites.net/api/send-notification', { data: data_encripted }, {
            headers
        })
            .then(response => {
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
                if (error == "AxiosError: Request failed with status code 401") {
                    navigate("/login")
                    alert("Sesión caducada!")
                }
            });
    }


    async function obtenerVAPID() {
        const headers = 'content-type: application/json; charset=utf-8'

        await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
            .then(response => {
                if (response.data !== null) {
                    setPublicKey(response.data.value.keys.publicKey)
                    statePublicKey = response.data.value.keys.publicKey
                    setPrivateKey(response.data.value.keys.privateKey)
                    statePrivateKey = response.data.value.keys.privateKey
                }

            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }

    const AddGuests = (event, value) => {
        // if (value !== undefined) {
        //     const newArray = guests.map((item) => {
        //         return {...item}
        //     })

        //     newArray.push(value)
        //     setGuests(newArray)
        // }
        let existe = false

        if (value !== undefined) {
            const newArray = guests.map((item) => {
                if (item.UserID == value.UserID) {
                    existe = true
                }
                return { ...item }
            })

            if (existe === false) {
                newArray.push(value)
            }
            setGuests(newArray)
        }
    }
    const DeleteGuests = (item) => {

        // const newArray = guests.map((guest, index) => {

        //     if (guest.id === item.id) {
        //         guests.splice(index, 1)

        //         return {...guest}
        //     }
        // })

        let newArray = []
        guests.map((guest, index) => {
            if (guest.UserID !== item.UserID) {
                newArray.push(guest)
            }
        })

        setGuests(newArray)
    }

    const handleGetLocationFromChild = (location) => {
        console.log("Entra al padre");
        console.log("Ubicación obtenida:", location);
        if (location.split("|")[0] == "Auto") {
            setEventCoords(JSON.parse(location.split("|")[1]))
            setInicialEventCoords(JSON.parse(location.split("|")[1]))
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: JSON.parse(location.split("|")[1]) }, (results, status) => {
                if (status === "OK") {
                    if (results[0]) {
                        console.log("Dirección encontrada:", results[0].formatted_address);
                        // setCoordsRenovadas(results[0].formatted_address)
                        setLocationValid(true);
                    } else {
                        console.log("No se encontraron resultados.");
                        setLocationValid(false);
                    }
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                    setLocationValid(false);
                }
            });
            setLocationValid(true);
        } else if (location.split("|")[0] == "Manual" && location.split("|")[1] == "") {
            setEventLocation("")
            setLocationValid(true);
        } else {
            setLocationValid(false);
        }

        // setEventLocation(location)

        // alert(`Ubicación obtenida: Latitud: ${location.lat}, Longitud: ${location.lng}`);
    };

    // FUNCION PARA CAMBIAR LA PRIVACIDAD DEL EVENTO
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const changeEventPrivacity = (event, newValue) => {
        setIndexEventPrivacity(newValue);
    };


    // FUNCION PARA TRADUCIR LA FECHA DEL EVENTO
    const traduceSelectedDate = (date) => {
        // setSelectedDate(date)
        // // setTraducedDate(new Date(date).toISOString());
        // const fecha = new Date(date);
        // const options = { year: 'numeric', month: 'long', day: 'numeric' };
        // const fechaEnEspanol = fecha.toLocaleDateString('es-ES', options);
        // setTraducedDate(fechaEnEspanol);


        let fechaTraducida = date.split('/')[2] + "-" + date.split('/')[1] + "-" + date.split('/')[0];
        return fechaTraducida;
    }


    // FUNCION PARA TRADUCIR LA HORA DEL EVENTO
    const traduceSelectedHour = (time) => {

        setSelectedHour(time)
        const fecha = new Date(time);
        const options = { hour: '2-digit', minute: '2-digit', hour12: false };
        const fechaEnEspanol = fecha.toLocaleDateString('es-ES', options);

        let fecha2 = fechaEnEspanol;
        fecha2 = fecha2.replace(/^[^,]*,\s*/g, '');
        setTraducedHour(fecha2);
    }



    const InputLock = styled('input')({
        display: 'none'
    });

    const BtnLock = styled('label')(({ eventPrivacity }) => ({
        // position: 'absolute',
        top: 'calc(50% - 32px)',
        left: 'calc(50% - 32px)',
        display: 'inline-block',
        background: (eventPrivacity ? '#ff5b5b' : '#20cca5'),
        width: 64,
        height: 64,
        boxSizing: 'border-box',
        padding: '12px 0 0 18px',
        borderRadius: '50%',
        cursor: 'pointer'
    }));

    const SvgLock = styled('svg')({
        fill: 'none',
        transform: 'translate3d(0, 0, 0)'
    });

    const BlingPath = styled('path')(({ props }) => ({
        stroke: '#fff',
        strokeWidth: 2.5,
        strokeLinecap: 'round',
        strokeDasharray: 3,
        strokeDashoffset: 15,
        transition: 'all 0.3s ease',
        animationName: 'bling6132',
        animationDuration: '0.3s',
        animationTimingFunction: 'linear',
        animationFillMode: 'forwards',
        animationDelay: '0.2s'
    }));

    const LockPath = styled('path')(({ eventPrivacity }) => ({
        stroke: '#fff',
        strokeWidth: 4,
        strokeLinejoin: 'round',
        strokeLinecap: 'round',
        strokeDasharray: (eventPrivacity ? 48 : 36),
        transition: 'all 0.4s ease',
        animationName: 'locked',
        animationDuration: '0.3s',
        animationTimingFunction: 'linear',
        animationFillMode: 'forwards'
    }));

    // const LockBPath = styled('path')({
    //     fill: '#fff',
    //     fillRule: 'evenodd',
    //     clipRule: 'evenodd',
    //     transform: 'rotate(8deg)',
    //     transformOrigin: '14px 20px',
    //     transition: 'all 0.2s ease'
    // });


    const LockBPath = styled('path')(({ eventPrivacity }) => ({
        fill: '#fff',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        transform: (eventPrivacity ? 'rotate(0deg)' : 'rotate(8deg)'),
        transformOrigin: '14px 20px',
        transition: 'all 0.2s ease'
    }));

    const [file, setFile] = useState()

    const handleImageUpload = (e) => {
        setFile(e.target.files[0])
        // Guardar el archivo en el estado local o realizar otras operaciones
    };

    const [value, setValue] = useState(null);

    const handleOnChange = (event, newValue) => {
        // console.log(newValue)
        setValue(newValue);
    };

    const getOptionLabel = (option) => {
        if (typeof option === 'string') {
            return option;
        }
        if (option instanceof String) {
            return option.toString();
        }
        return option.label;
    };

    // Agregar estilos globales al scrollbar
    const customScrollbarStyles = `
::-webkit-scrollbar {
  width: 10px;
}


::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 8px;
}


::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}


::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`;

    function decryptData(encryptedText) {
        // Define la misma clave que usaste en el backend
        const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

        // Decodifica el texto encriptado de base64
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
        const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

        // Deriva la clave usando SHA256
        const hashedKey = CryptoJS.SHA256(key);

        // Desencripta el contenido
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedContent },
            hashedKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convierte el resultado a texto legible
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    // EFFECTS

    useEffect(() => {
        const token = localStorage.getItem('jwt_token');
        if (!token) {
            console.log("el token no es valido")
            navigate("/")
        } else {
            getFriends();
            console.log(props.eventDetailsReducer.location)

            setEventName(props.eventDetailsReducer.title)
            setEventDescription(props.eventDetailsReducer.description)

            setEventImage(props.eventDetailsReducer.image)
            setInitialEventImage(props.eventDetailsReducer.image)

            // if (props.eventDetailsReducer.location.split("|")[0] == "Auto") {
            //     setEventLocation(props.eventDetailsReducer.location.split("|")[1])
            // } else {
            //     setEventLocation(props.eventDetailsReducer.location.split("|")[1])
            // }

            if (props.eventDetailsReducer.locationCoords) {

                startCoords = JSON.parse(props.eventDetailsReducer.locationCoords)
                setEventCoords(JSON.parse(props.eventDetailsReducer.locationCoords))
                setInicialEventCoords(JSON.parse(props.eventDetailsReducer.locationCoords))
            }
            setEventLocation(props.eventDetailsReducer.location)
            setInicialEventLocation(props.eventDetailsReducer.location)
            setCoordsRenovadas(props.eventDetailsReducer.location)
            // setSelectedDate(dayjs(props.eventDetailsReducer.startDay))
            let fecha = traduceSelectedDate(props.eventDetailsReducer.startDay)
            setSelectedDate(dayjs(props.eventDetailsReducer.startDay))
            setSelectedHour(dayjs("2024-01-01T" + props.eventDetailsReducer.startTime))
            traduceSelectedHour(dayjs("2024-01-01T" + props.eventDetailsReducer.startTime))

            setEventCaracteristics(props.eventDetailsReducer.caracteristics)

            if (props.eventDetailsReducer.privacity == 'PUBLICO') {
                setEventPrivacity(false)
            } else {
                setEventPrivacity(true)
            }


            setEventTypeAuto(props.eventDetailsReducer.image)



            let guestsList = props.eventDetailsReducer.guestsId.split("; ")
            guestsList.splice(guestsList.length - 1, 1)
            // setGuests(guestsList)




            var data = {
                loguedUser: props.user.id,
                usersList: guestsList
            }

            const jsonData = JSON.stringify(data);
            const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();


            const headers = 'content-type: application/json; charset=utf-8'
            axios.post(`https://socializeapi.azurewebsites.net/api/GetUsers`, { data: data_encripted }, {
                headers
            })
                .then(response => {
                    let decripted_response = decryptData(response.data)
                    let convertedToArray = JSON.parse(decripted_response)


                    setAvailableUsers(convertedToArray)
                    let listaInvitados = []


                    for (let a = 0; a < convertedToArray.length; a++) {
                        for (let i = 0; i < guestsList.length; i++) {

                            if (convertedToArray[a].UserID == parseInt(guestsList[i])) {
                                // guests.push(response.data[a])
                                listaInvitados.push(convertedToArray[a])
                            }
                        }
                    }

                    setGuests(listaInvitados)

                })
                .catch(error => {
                    console.log(`Error obteniendo datos: ${error}`);
                    if (error == "AxiosError: Request failed with status code 401") {
                        navigate("/login")
                        alert("Sesión caducada!")
                    }
                })



            eventTypes.map((item) => {
                if (item !== props.eventDetailsReducer.eventType) {
                    setEventTypeManual(props.eventDetailsReducer.eventType)
                } else {
                    setEventTypeAuto(props.eventDetailsReducer.eventType)
                }
            })
        }

    }, []);

    const onChangeLocation = (location) => {
        // setEventLocation(location)
        console.log("cambio location")
        console.log(location)
        setEventCoords(location)
        // setCoordsRenovadas(location)
    };

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 768); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const uploadImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Realizar la conversión de la imagen al formato necesario (base64)
            const reader = new FileReader();
            reader.onloadend = () => {
                let base64String = reader.result;
                base64String = base64String.split(',')[1];
                setEventImage(base64String)
                // Enviar la imagen al endpoint a través de una petición a SQL
                // Aquí se realizaría la lógica para enviar la imagen en formato base64 a la base de datos
            };
            setEventImageBlob(file)
            reader.readAsDataURL(file);
        }
    };

    return (
        <Container maxWidth="lg" sx={{ py: 4, mt: isLargeScreen && 2 }}>
            {isLargeScreen && <Header></Header>}
            {isLargeScreen && <Sidebar></Sidebar>}




            {isLargeScreen && (
                <Box sx={{ width: '100%', typography: 'body1', marginBottom: 8 }}>
                    <Box sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        mb: 3,
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'background.paper',
                        zIndex: 1000,
                        padding: '10px 0',
                        // boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="event creation tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Información Básica" />
                            <Tab label="Ubicación" />
                            {eventPrivacity && <Tab label="Invitados" />}
                            <Tab label="Importante" />
                            {(eventTypeManual && eventTypeManual !== "No definido") && <Tab label="Extra" />}
                        </Tabs>
                    </Box>

                    {/* Panel de Información Básica */}
                    {tabValue === 0 && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Información del Evento
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 3,
                                        }}
                                    >
                                        <Fade in={true} timeout={800}>
                                            <Card
                                                elevation={eventImage ? 3 : 0}
                                                sx={{
                                                    width: '100%',
                                                    height: isLargeScreen ? 300 : 200,
                                                    borderRadius: 4,
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                    transition: 'all 0.8s ease-in-out', // Increased transition duration
                                                    bgcolor: eventImage ? 'background.paper' : 'grey.50',
                                                    '&:hover': {
                                                        transform: 'scale(1.01)',
                                                        boxShadow: eventImage ? 6 : 0
                                                    }
                                                }}
                                            >
                                                {eventImage ? (
                                                    eventImage !== initialEventImage ? (
                                                        <CardMedia
                                                            component="img"
                                                            image={`data:image/png;base64,${eventImage}`}
                                                            alt="Event preview"
                                                            sx={{
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                transition: 'all 0.8s ease-in-out'
                                                            }}
                                                        />
                                                    ) : (
                                                        <CardMedia
                                                            component="img"
                                                            image={`${eventImage}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                                                            alt="Event preview"
                                                            sx={{
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                transition: 'all 0.8s ease-in-out'
                                                            }}
                                                        />
                                                    )
                                                ) : (
                                                    <Box
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: 2
                                                        }}
                                                    >
                                                        <ImageIcon
                                                            sx={{
                                                                fontSize: 60,
                                                                color: 'grey.400',
                                                                opacity: 0.8
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body1"
                                                            color="text.secondary"
                                                            sx={{
                                                                fontStyle: 'italic',
                                                                opacity: 0.8
                                                            }}
                                                        >
                                                            Agregale una imagen a tu evento (opcional)
                                                        </Typography>
                                                    </Box>
                                                )}

                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 16,
                                                        right: 16,
                                                        display: 'flex',
                                                        gap: 1
                                                    }}
                                                >
                                                    <Zoom in={true} timeout={500}>
                                                        <IconButton
                                                            component="label"
                                                            sx={{
                                                                bgcolor: 'primary.main',
                                                                color: 'white',
                                                                '&:hover': {
                                                                    bgcolor: 'primary.dark',
                                                                    transform: 'scale(1.1)'
                                                                },
                                                                transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                            }}
                                                        >
                                                            <CameraAltIcon />
                                                            <input
                                                                type="file"
                                                                hidden
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                onChange={(event) => uploadImage(event)}
                                                            />
                                                        </IconButton>
                                                    </Zoom>

                                                    {eventImage && (
                                                        <Zoom in={true} timeout={500}>
                                                            <IconButton
                                                                onClick={() => {
                                                                    setEventImage('');
                                                                    setEventImageBlob('');
                                                                    fileInputRef.current.value = '';
                                                                }}
                                                                sx={{
                                                                    bgcolor: 'error.main',
                                                                    color: 'white',
                                                                    '&:hover': {
                                                                        bgcolor: 'error.dark',
                                                                        transform: 'scale(1.1)'
                                                                    },
                                                                    transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Zoom>
                                                    )}
                                                </Box>
                                            </Card>
                                        </Fade>

                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        label="Nombre del Evento"
                                        value={eventName}
                                        onChange={(e) => setEventName(e.target.value)}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        label="Descripción"
                                        multiline
                                        rows={4}
                                        value={eventDescription}
                                        onChange={(e) => setEventDescription(e.target.value)}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Card sx={{ mb: 2 }}>
                                        <CardContent>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Fecha y Hora
                                            </Typography>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', sm: 'row' },
                                                gap: 2,
                                                width: '100%'
                                            }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                    <DatePicker
                                                        label="Fecha del Evento"
                                                        value={selectedDate}
                                                        onChange={(newValue) => setSelectedDate(newValue)}
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiInputBase-root': {
                                                                width: '100%'
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <MobileTimePicker
                                                        label="Hora del Evento"
                                                        value={selectedHour}
                                                        onChange={(event) => { traduceSelectedHour(event) }}
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiInputBase-root': {
                                                                width: '100%'
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {/* Tipo de evento */}

                                {/* <Grid item xs={12}>
                                <Card>
                                    <CardContent sx={{
                                        height: '124px', // Initial fixed height
                                        transition: 'height 0.3s ease',
                                        overflow: 'hidden',
                                        '&:focus-within': {
                                            height: '250px' // Expanded height when TextField is focused
                                        }
                                    }}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Tipo de Evento
                                        </Typography>
                                        <FormControl fullWidth>
                                            <TextField
                                                fullWidth
                                                size='small'
                                                label="Buscar tipo de evento"
                                                value={eventTypeManual}
                                                onChange={(e) => setEventTypeManual(e.target.value)}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: eventTypeManual && (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => setEventTypeManual('')}
                                                                edge="end"
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </FormControl>
                                        <Box
                                            sx={{
                                                mt: 2,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: 1
                                            }}
                                        >
                                            {filterEventTypes(eventTypeManual)
                                                .map((type, index) => (
                                                    <Button
                                                        key={index}
                                                        variant={eventTypeManual === type ? "contained" : "outlined"}
                                                        size="small"
                                                        onClick={() => setEventTypeManual(type)}
                                                        sx={{
                                                            borderRadius: '5px',
                                                            textTransform: 'none'
                                                        }}
                                                    >
                                                        {type}
                                                    </Button>
                                                ))
                                            }
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid> */}
                                <Grid item xs={12}>
                                    <Card elevation={0}>
                                        <CardContent>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Privacidad
                                            </Typography>
                                            <Box sx={{
                                                mt: 2,
                                                p: 3,
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: 2,
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}>
                                                {/* TIPO DE PRIVACIDAD */}
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    mb: 3
                                                }}>

                                                    {/* <Typography
                                                    fontSize={14}
                                                    sx={{
                                                        color: eventPrivacity ? '#ff5b5b' : '#20cca5',
                                                        mb: 2,
                                                        textAlign: 'center',
                                                        maxWidth: '80%',
                                                        fontStyle: 'italic'
                                                    }}
                                                >
                                                    {eventPrivacity
                                                        ? "(Privado: Solo usted y los usuarios que invite podrán ver este Evento)."
                                                        : "(Público: Todos los que entren HiSocialize verán este Evento)."}
                                                </Typography> */}
                                                </Box>

                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    mt: 3
                                                }}>
                                                    {eventPrivacity ? (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#ffe0b2',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#ffcc80'
                                                                    }
                                                                }}
                                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}
                                                            >
                                                                <HttpsIcon sx={{ color: '#ff9100', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'#ff9100'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Privado
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#838fcf',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#6573c3'
                                                                    }
                                                                }}
                                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}
                                                            >
                                                                <PublicIcon sx={{ color: '#3f51b5', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'primary'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Público
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {/* Panel de Ubicación */}
                    {tabValue === 1 && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Ubicación del Evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {eventCoords !== '' ?
                                                <div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                        <Typography mb={2} mt={1} textAlign={'center'} variant='caption'>{eventLocation}</Typography>
                                                        <Button variant='contained' style={{ marginBottom: 16, marginInline: 'auto' }} onClick={() => { setEventCoords(''); setEventLocation('') }}>Cambiar ubicación</Button>
                                                    </div>
                                                    <div style={{ position: 'relative' }}>
                                                        <Maps
                                                            defaultCenter={{ lat: eventCoords.lat, lng: eventCoords.lng }}
                                                            onLocation={onChangeLocation} // el valor se onLocation se deposita en onChangeLocation (es para ajustar la ubicacion)
                                                            initialCoords={inicialEventCoords}
                                                        ></Maps>
                                                        <CircleIcon style={{ position: 'absolute', color: '#f44336', top: isLargeScreen ? 'calc(50% - 4px)' : 'calc(150px - 4px)', left: isLargeScreen ? 'calc(50% - 4px)' : 'calc(50% - 4px)', fontSize: 8 }}></CircleIcon>
                                                    </div>
                                                </div>
                                                :
                                                <MapWithAutocomplete onGetLocationCoords={handleGetLocationFromChild} onGetLocation={(e) => { setEventLocation(e) }}></MapWithAutocomplete>
                                            }
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Invitados */}
                    {(tabValue === 2 && eventPrivacity == true) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Gestión de Invitados
                            </Typography>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Buscar Amigos"
                                                value={searchFriends}
                                                onChange={(e) => setSearchFriends(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                                {filteredFriends.map((friend, index) => (
                                                    <ListItem
                                                        key={index}
                                                        secondaryAction={
                                                            <Checkbox
                                                                edge="end"
                                                                onChange={() => {
                                                                    const updatedFriends = friends.map(f => {
                                                                        if (f.userID === friend.userID) {
                                                                            return { ...f, selected: !f.selected };
                                                                        }
                                                                        return f;
                                                                    });
                                                                    setFriends(updatedFriends);
                                                                }}
                                                                checked={friend.selected || false}
                                                            />
                                                        }
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar src={friend.avatar} />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={friend.nameUser}
                                                            secondary={friend.email}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Características */}
                    {((tabValue === 3 && eventPrivacity === true) || (tabValue === 2 && eventPrivacity === false)) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Información importante del Evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Extras */}
                    {((tabValue === 4 && eventPrivacity === true && (eventTypeManual && eventTypeManual !== "No definido")) || (tabValue === 3 && eventPrivacity === false && (eventTypeManual && eventTypeManual !== "No definido"))) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Caracteristicas extras del evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Botones de Acción */}
                    <Box sx={{
                        p: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        bottom: 20,
                        left: 0,
                        right: 0,
                        width: '100%',
                        maxWidth: '100%',
                        zIndex: 1000,
                        px: { xs: 2, sm: 4 }, // Responsive padding
                        mx: 'auto', // Center the box
                        boxSizing: 'border-box', // Include padding in width calculation
                        gap: 2 // Add spacing between buttons
                    }}>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/')}
                            startIcon={<KeyboardArrowLeftIcon />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 2,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '120px',
                                color: 'grey.700',
                                borderColor: 'grey.400',
                                '&:hover': {
                                    bgcolor: 'grey.100',
                                    borderColor: 'grey.500',
                                    transform: 'scale(1.04)',
                                    transition: 'transform 0.2s ease-in-out'
                                }
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            onClick={editEvent}
                            disabled={loading || !eventName}
                            startIcon={loading ? <CircularProgress size={20} /> : <EventAvailableIcon sx={{ fontSize: 24 }} />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 3,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '160px',
                                bgcolor: '#FFA726', // Orange color associated with editing
                                '&:hover': {
                                    bgcolor: '#FB8C00', // Darker orange on hover
                                    transform: 'scale(1.04)',
                                    transition: 'transform 0.2s ease-in-out'
                                }
                            }}
                        >
                            {loading ? 'Modificando el Evento...' : 'Editar Evento'}
                        </Button>
                    </Box>

                    {/* Alerta de Errores */}
                    {showAlert && (
                        typeAlert === 'error' ? (

                            <Alert
                                severity="error"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                Por favor, complete los siguientes campos:{alertMsg}
                            </Alert>
                        ) : (

                            <Alert
                                severity="info"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                {eventPrivacity ? "Solo tú y los usuarios que invites podrán ver este evento" : "Todos los que entren HiSocialize verán este Evento"}
                            </Alert>
                        )

                    )}
                </Box>

            )}

            {!isLargeScreen && (
                <Box sx={{ width: '100%', typography: 'body1', marginBottom: 8 }}>
                    <Box sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        mb: 3,
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'background.paper',
                        zIndex: 1000,
                        padding: '10px 0',
                        // boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="event creation tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Información Básica" />
                            <Tab label="Ubicación" />
                            {eventPrivacity && <Tab label="Invitados" />}
                            <Tab label="Importante" />
                            {(eventTypeManual && eventTypeManual !== "No definido") && <Tab label="Extra" />}
                        </Tabs>
                    </Box>

                    {/* Panel de Información Básica */}
                    {tabValue === 0 && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Información del Evento
                            </Typography>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 3,
                                        }}
                                    >
                                        <Fade in={true} timeout={800}>
                                            <Card
                                                elevation={eventImage ? 3 : 0}
                                                sx={{
                                                    width: '100%',
                                                    height: isLargeScreen ? 300 : 200,
                                                    borderRadius: 4,
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                    transition: 'all 0.8s ease-in-out', // Increased transition duration
                                                    bgcolor: eventImage ? 'background.paper' : 'grey.50',
                                                    '&:hover': {
                                                        transform: 'scale(1.01)',
                                                        boxShadow: eventImage ? 6 : 0
                                                    }
                                                }}
                                            >
                                                {eventImage ? (
                                                    eventImage !== initialEventImage ? (
                                                        <CardMedia
                                                            component="img"
                                                            image={`data:image/png;base64,${eventImage}`}
                                                            alt="Event preview"
                                                            sx={{
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                transition: 'all 0.8s ease-in-out'
                                                            }}
                                                        />
                                                    ) : (
                                                        <CardMedia
                                                            component="img"
                                                            image={`${eventImage}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                                                            alt="Event preview"
                                                            sx={{
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                transition: 'all 0.8s ease-in-out'
                                                            }}
                                                        />
                                                    )
                                                ) : (
                                                    <Box
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: 2
                                                        }}
                                                    >
                                                        <ImageIcon
                                                            sx={{
                                                                fontSize: 60,
                                                                color: 'grey.400',
                                                                opacity: 0.8
                                                            }}
                                                        />
                                                        <Typography
                                                            variant="body1"
                                                            color="text.secondary"
                                                            sx={{
                                                                fontStyle: 'italic',
                                                                opacity: 0.8
                                                            }}
                                                        >
                                                            Agregale una imagen a tu evento (opcional)
                                                        </Typography>
                                                    </Box>
                                                )}

                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: 16,
                                                        right: 16,
                                                        display: 'flex',
                                                        gap: 1
                                                    }}
                                                >
                                                    <Zoom in={true} timeout={500}>
                                                        <IconButton
                                                            component="label"
                                                            sx={{
                                                                bgcolor: 'primary.main',
                                                                color: 'white',
                                                                '&:hover': {
                                                                    bgcolor: 'primary.dark',
                                                                    transform: 'scale(1.1)'
                                                                },
                                                                transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                            }}
                                                        >
                                                            <CameraAltIcon />
                                                            <input
                                                                type="file"
                                                                hidden
                                                                accept="image/*"
                                                                ref={fileInputRef}
                                                                onChange={(event) => uploadImage(event)}
                                                            />
                                                        </IconButton>
                                                    </Zoom>

                                                    {eventImage && (
                                                        <Zoom in={true} timeout={500}>
                                                            <IconButton
                                                                onClick={() => {
                                                                    setEventImage('');
                                                                    setEventImageBlob('');
                                                                    fileInputRef.current.value = '';
                                                                }}
                                                                sx={{
                                                                    bgcolor: 'error.main',
                                                                    color: 'white',
                                                                    '&:hover': {
                                                                        bgcolor: 'error.dark',
                                                                        transform: 'scale(1.1)'
                                                                    },
                                                                    transition: 'all 0.8s ease-in-out' // Increased transition duration
                                                                }}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                        </Zoom>
                                                    )}
                                                </Box>
                                            </Card>
                                        </Fade>

                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        label="Nombre del Evento"
                                        value={eventName}
                                        onChange={(e) => setEventName(e.target.value)}
                                        margin="normal"
                                    />
                                    <TextField
                                        fullWidth
                                        label="Descripción"
                                        multiline
                                        rows={4}
                                        value={eventDescription}
                                        onChange={(e) => setEventDescription(e.target.value)}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Card sx={{ mb: 2 }}>
                                        <CardContent>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Fecha y Hora
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                    <DatePicker
                                                        label="Fecha del Evento"
                                                        value={selectedDate}
                                                        onChange={(newValue) => setSelectedDate(newValue)}
                                                        renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                                                    />
                                                </LocalizationProvider>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <MobileTimePicker
                                                        label="Hora del Evento"
                                                        value={selectedHour} onChange={(event) => { traduceSelectedHour(event) }}
                                                        renderInput={(params) => <TextField {...params} sx={{ flex: 1 }} />}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {/* Tipo de evento */}

                                {/* <Grid item xs={12}>
                            <Card>
                                <CardContent sx={{
                                    height: '124px', // Initial fixed height
                                    transition: 'height 0.3s ease',
                                    overflow: 'hidden',
                                    '&:focus-within': {
                                        height: '250px' // Expanded height when TextField is focused
                                    }
                                }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Tipo de Evento
                                    </Typography>
                                    <FormControl fullWidth>
                                        <TextField
                                            fullWidth
                                            size='small'
                                            label="Buscar tipo de evento"
                                            value={eventTypeManual}
                                            onChange={(e) => setEventTypeManual(e.target.value)}
                                            margin="normal"
                                            InputProps={{
                                                endAdornment: eventTypeManual && (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setEventTypeManual('')}
                                                            edge="end"
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormControl>
                                    <Box
                                        sx={{
                                            mt: 2,
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1
                                        }}
                                    >
                                        {filterEventTypes(eventTypeManual)
                                            .map((type, index) => (
                                                <Button
                                                    key={index}
                                                    variant={eventTypeManual === type ? "contained" : "outlined"}
                                                    size="small"
                                                    onClick={() => setEventTypeManual(type)}
                                                    sx={{
                                                        borderRadius: '5px',
                                                        textTransform: 'none'
                                                    }}
                                                >
                                                    {type}
                                                </Button>
                                            ))
                                        }
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid> */}
                                <Grid item xs={12}>
                                    <Card elevation={0}>
                                        <CardContent>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Privacidad
                                            </Typography>
                                            <Box sx={{
                                                mt: 2,
                                                p: 3,
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: 2,
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}>
                                                {/* TIPO DE PRIVACIDAD */}
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    mb: 3
                                                }}>

                                                    {/* <Typography
                                                fontSize={14}
                                                sx={{
                                                    color: eventPrivacity ? '#ff5b5b' : '#20cca5',
                                                    mb: 2,
                                                    textAlign: 'center',
                                                    maxWidth: '80%',
                                                    fontStyle: 'italic'
                                                }}
                                            >
                                                {eventPrivacity
                                                    ? "(Privado: Solo usted y los usuarios que invite podrán ver este Evento)."
                                                    : "(Público: Todos los que entren HiSocialize verán este Evento)."}
                                            </Typography> */}
                                                </Box>

                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    mt: 3
                                                }}>
                                                    {eventPrivacity ? (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#ffe0b2',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#ffcc80'
                                                                    }
                                                                }}
                                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}
                                                            >
                                                                <HttpsIcon sx={{ color: '#ff9100', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'#ff9100'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Privado
                                                            </Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{
                                                            textAlign: 'center',
                                                            transition: 'transform 0.3s ease',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}>
                                                            <IconButton
                                                                sx={{
                                                                    backgroundColor: '#838fcf',
                                                                    p: 3,
                                                                    '&:hover': {
                                                                        backgroundColor: '#6573c3'
                                                                    }
                                                                }}
                                                                onClick={() => { setEventPrivacity(!eventPrivacity); setTypeAlert('info'); setShowAlert(true) }}
                                                            >
                                                                <PublicIcon sx={{ color: '#3f51b5', fontSize: 72 }} />
                                                            </IconButton>
                                                            <Typography
                                                                color={'primary'}
                                                                fontFamily="Fredoka, sans-serif"
                                                                sx={{ mt: 1, fontWeight: 500 }}
                                                            >
                                                                Público
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Box>
                    )}

                    {/* Panel de Ubicación */}
                    {tabValue === 1 && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Ubicación del Evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {eventCoords !== '' ?
                                                <div>
                                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                        <Typography mb={2} mt={1} textAlign={'center'} variant='caption'>{eventLocation}</Typography>
                                                        <Button variant='contained' style={{ marginBottom: 16, marginInline: 'auto' }} onClick={() => { setEventCoords(''); setEventLocation('') }}>Cambiar ubicación</Button>
                                                    </div>
                                                    <div style={{ position: 'relative' }}>
                                                        <Maps
                                                            defaultCenter={{ lat: eventCoords.lat, lng: eventCoords.lng }}
                                                            onLocation={onChangeLocation} // el valor se onLocation se deposita en onChangeLocation (es para ajustar la ubicacion)
                                                            initialCoords={inicialEventCoords}
                                                        ></Maps>
                                                        <CircleIcon style={{ position: 'absolute', color: '#f44336', top: isLargeScreen ? 'calc(50% - 4px)' : 'calc(150px - 4px)', left: isLargeScreen ? 'calc(50% - 4px)' : 'calc(50% - 4px)', fontSize: 8 }}></CircleIcon>
                                                    </div>
                                                </div>
                                                :
                                                <MapWithAutocomplete onGetLocationCoords={handleGetLocationFromChild} onGetLocation={(e) => { setEventLocation(e) }}></MapWithAutocomplete>
                                            }
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Invitados */}
                    {(tabValue === 2 && eventPrivacity == true) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Gestión de Invitados
                            </Typography>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Alert severity="info" sx={{ mb: 2 }}>
                                                No te preocupes si no encuentras a alguien en tu lista de amigos. Después de crear el evento, podrás compartir el enlace de invitación con cualquier persona.
                                            </Alert>
                                            <TextField
                                                fullWidth
                                                label="Buscar Amigos"
                                                value={searchFriends}
                                                onChange={(e) => setSearchFriends(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                                {filteredFriends.map((friend, index) => (
                                                    <ListItem
                                                        key={index}
                                                        secondaryAction={
                                                            <Checkbox
                                                                edge="end"
                                                                onChange={() => {
                                                                    const updatedFriends = friends.map(f => {
                                                                        if (f.userID === friend.userID) {
                                                                            return { ...f, selected: !f.selected };
                                                                        }
                                                                        return f;
                                                                    });
                                                                    setFriends(updatedFriends);
                                                                }}
                                                                checked={friend.selected || false}
                                                            />
                                                        }
                                                    >
                                                        <ListItemAvatar>
                                                            <Avatar src={friend.avatar} />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={friend.nameUser}
                                                            secondary={friend.email}
                                                        />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Características */}
                    {((tabValue === 3 && eventPrivacity === true) || (tabValue === 2 && eventPrivacity === false)) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Información importante del Evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Panel de Extras */}
                    {((tabValue === 4 && eventPrivacity === true && (eventTypeManual && eventTypeManual !== "No definido")) || (tabValue === 3 && eventPrivacity === false && (eventTypeManual && eventTypeManual !== "No definido"))) && (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {/* Características del Evento */}
                                Caracteristicas extras del evento
                            </Typography>
                            <Card>
                                <CardContent>
                                    <TextField
                                        fullWidth
                                        label="Características Especiales"
                                        multiline
                                        rows={4}
                                        value={eventCaracteristics}
                                        onChange={(e) => setEventCaracteristics(e.target.value)}
                                        placeholder="Describe las características especiales del evento (opcional)"
                                        helperText="Por ejemplo: Código de vestimenta, elementos a traer, restricciones, etc."
                                    />
                                </CardContent>
                            </Card>
                        </Box>
                    )}

                    {/* Botones de Acción */}
                    <Box sx={{
                        p: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        bottom: 20,
                        left: 0,
                        right: 0,
                        width: '100%',
                        maxWidth: '100%',
                        zIndex: 1000,
                        px: { xs: 2, sm: 4 }, // Responsive padding
                        mx: 'auto', // Center the box
                        boxSizing: 'border-box', // Include padding in width calculation
                        gap: 2 // Add spacing between buttons
                    }}>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/')}
                            startIcon={<KeyboardArrowLeftIcon />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 2,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '120px',
                                color: 'grey.700',
                                borderColor: 'grey.400',
                                '&:hover': {
                                    bgcolor: 'grey.100',
                                    borderColor: 'grey.500',
                                    transform: 'scale(1.04)',
                                    transition: 'transform 0.2s ease-in-out'
                                }
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            variant="contained"
                            onClick={editEvent}
                            disabled={loading || !eventName}
                            startIcon={loading ? <CircularProgress size={20} /> : <EventAvailableIcon sx={{ fontSize: 24 }} />}
                            sx={{
                                borderRadius: 20,
                                boxShadow: 3,
                                padding: '8px 16px',
                                fontSize: '1rem',
                                fontWeight: 600,
                                textTransform: 'none',
                                minWidth: '160px',
                                bgcolor: '#FFA726', // Orange color associated with editing
                                '&:hover': {
                                    bgcolor: '#FB8C00', // Darker orange on hover
                                    transform: 'scale(1.04)',
                                    transition: 'transform 0.2s ease-in-out'
                                }
                            }}
                        >
                            {loading ? 'Modificando el Evento...' : 'Editar Evento'}
                        </Button>
                    </Box>

                    {/* Alerta de Errores */}
                    {showAlert && (
                        typeAlert === 'error' ? (

                            <Alert
                                severity="error"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                Por favor, complete los siguientes campos:{alertMsg}
                            </Alert>
                        ) : (

                            <Alert
                                severity="info"
                                sx={{ mt: 2 }}
                                onClose={() => setShowAlert(false)}
                            >
                                {eventPrivacity ? "Solo tú y los usuarios que invites podrán ver este evento" : "Todos los que entren HiSocialize verán este Evento"}
                            </Alert>
                        )

                    )}
                </Box>
            )}


        </Container>
    );
}

export default connect(mapStateToProps)(EditEvent)


// Este es un formato de ejemplo. Borra o agregar lo que quieras